import { render, staticRenderFns } from "./HLDetail.vue?vue&type=template&id=59085b2e&scoped=true"
import script from "./HLDetail.vue?vue&type=script&lang=js"
export * from "./HLDetail.vue?vue&type=script&lang=js"
import style0 from "./HLDetail.vue?vue&type=style&index=0&id=59085b2e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59085b2e",
  null
  
)

export default component.exports